"use client";

import { useTranslations } from "@/i18n/client";

/** Keyboard-only skip link that jumps focus past the header to `#main-content`. */
export const SkipToContent = () => {
	const t = useTranslations();

	return (
		<a
			href="#main-content"
			className="sr-only font-display text-sm text-text-dark-text-1 focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-brand-sand-10 focus:px-4 focus:py-2 focus:shadow-md focus:outline-2 focus:outline-offset-2 focus:outline-status-accessibility-focus"
		>
			{t("Skip to content")}
		</a>
	);
};
